import { render } from "./BulkPaymentDialog.vue?vue&type=template&id=06801dfb&scoped=true"
import script from "./BulkPaymentDialog.vue?vue&type=script&lang=js"
export * from "./BulkPaymentDialog.vue?vue&type=script&lang=js"

import "./BulkPaymentDialog.vue?vue&type=style&index=0&id=06801dfb&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06801dfb"]])

export default __exports__